// import { useState } from 'react';
// import { X } from 'lucide-react';

// const ProfileUpdateAlert = ({ userName }) => {
//   const [isVisible, setIsVisible] = useState(true);

//   if (!isVisible) return null;

//   return (
//     <div className="relative mb-2">
//       <div className="bg-orange-100 text-xs p-4 rounded text-blue-800 relative shadow">
//         {/* Close Button - Positioned Top Right */}
//         <button
//           onClick={() => setIsVisible(false)}
//           className="absolute top-1 right-1 text-blue-800 hover:text-blue-600"
//         >
//           <X size={16} />
//         </button>

//         <p className="font-medium">
//           Welcome <span className='font-semibold'>{userName || 'User'},</span>
//         </p>
//         <p>
//       আপনার অবস্থান অনুযায়ী নিয়মিত টেন্ডার আপডেট পেতে, "Edit Profile" থেকে আপনার প্রোফাইল আপডেট করুন এবং "Selected Category" সেকশনে আপনার ক্যাটেগরি পরিবর্তন করুন। আপনি "Change Password" সেকশন থেকে আপনার পাসওয়ার্ডও আপডেট করতে পারবেন। অতিরিক্ত সহায়তার জন্য, "Get Support" অপশন ব্যবহার করে আমাদের সাথে যোগাযোগ করুন।

// টেন্ডার প্রকাশ করতে, "Tender Publish" সেকশনে গিয়ে "See Details" অপশন নির্বাচন করে ফর্ম পূরণ করুন। "View & Edit My Tender"-এ যাচাই করার পর, "Pay Now" অপশন থেকে পেমেন্ট সম্পন্ন করুন, এবং আপনার টেন্ডার ৭২ ঘণ্টার মধ্যে প্রকাশিত হবে। আপনি "View all My Published Tender " থেকে আপনার প্রকাশিত টেন্ডার দেখতে পারবেন।

// যদি আপনি সাবস্ক্রাইব না করেন, তবে আপনি ফ্রি টেন্ডারগুলি দেখতে পারবেন এবং "Keyword Search" ব্যবহার করতে পারবেন। পূর্ণ অ্যাক্সেস, "My Favourite" এবং "Advance Search" ফিচার পেতে "Buy Subscription" থেকে একটি প্যাকেজ কিনুন। পেমেন্ট সফলভাবে সম্পন্ন করার পর, আপনি "Bill Status" থেকে পেমেন্ট হিস্ট্রি দেখতে এবং "Invoice" থেকে পেমেন্ট হিস্ট্রি ডাউনলোড করতে পারবেন। আপনার মতামত "ফিডব্যাক" অপশন থেকে শেয়ার করতে পারবেন।
//         </p>

//       </div>
//     </div>



//   );
// };

// export default ProfileUpdateAlert;


// import { useState } from "react";
// import { X } from "lucide-react";

// const WelcomeMessage = ({ userName }) => {
//   const [isVisible, setIsVisible] = useState(true);

//   return (
//     <div>
//       {/* Welcome Message (This will always stay) */}
//       <p className="font-bold text-xl text-[#FEA159]  p-2">
//         Welcome <span className="font-semibold">{userName || "User"},</span>
//       </p>

//       {/* Info Box (Can be closed) */}
//       {isVisible && (
//         <div className="relative mb-2">
//           <div className="bg-orange-100 text-xs p-4 rounded text-blue-800 relative shadow">
//             {/* Close Button */}
//             <button
//               onClick={() => setIsVisible(false)}
//               className="absolute top-1 right-1 text-blue-800 hover:text-blue-600"
//             >
//               <X size={16} />
//             </button>

//             <p>
//               আপনার অবস্থান অনুযায়ী নিয়মিত টেন্ডার আপডেট পেতে, "Edit Profile" থেকে আপনার প্রোফাইল আপডেট করুন এবং "Selected Category" সেকশনে আপনার ক্যাটেগরি পরিবর্তন করুন। আপনি "Change Password" সেকশন থেকে আপনার পাসওয়ার্ডও আপডেট করতে পারবেন। অতিরিক্ত সহায়তার জন্য, "Get Support" অপশন ব্যবহার করে আমাদের সাথে যোগাযোগ করুন।

//               টেন্ডার প্রকাশ করতে, "Tender Publish" সেকশনে গিয়ে "See Details" অপশন নির্বাচন করে ফর্ম পূরণ করুন। "View & Edit My Tender"-এ যাচাই করার পর, "Pay Now" অপশন থেকে পেমেন্ট সম্পন্ন করুন, এবং আপনার টেন্ডার ৭২ ঘণ্টার মধ্যে প্রকাশিত হবে। আপনি "View all My Published Tender " থেকে আপনার প্রকাশিত টেন্ডার দেখতে পারবেন।

//               যদি আপনি সাবস্ক্রাইব না করেন, তবে আপনি ফ্রি টেন্ডারগুলি দেখতে পারবেন এবং "Keyword Search" ব্যবহার করতে পারবেন। পূর্ণ অ্যাক্সেস, "My Favourite" এবং "Advance Search" ফিচার পেতে "Buy Subscription" থেকে একটি প্যাকেজ কিনুন। পেমেন্ট সফলভাবে সম্পন্ন করার পর, আপনি "Bill Status" থেকে পেমেন্ট হিস্ট্রি দেখতে এবং "Invoice" থেকে পেমেন্ট হিস্ট্রি ডাউনলোড করতে পারবেন। আপনার মতামত "ফিডব্যাক" অপশন থেকে শেয়ার করতে পারবেন।
//             </p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default WelcomeMessage;


import { useState, useEffect } from "react";
import { X } from "lucide-react";
import apiClient from "../../Api/apiClient"; // Adjust the import based on your project structure

const WelcomeMessage = ({ userName = "User" }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [userType, setUserType] = useState(""); // State to store user_type
  const [profileData, setProfileData] = useState({}); // State to store profile data

  // Fetch user_type and profile data from API
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        // Fetch profile data
        const response = await apiClient.get("/user/profile");

        // Set user_type from the response
        const fetchedUserType = response.data?.user_type || "user"; // Default to 'user' if user_type is missing
        setUserType(fetchedUserType);

        // Set profile data
        setProfileData({
          name: response.data.data.full_name || "",
          description: response.data.data.description || "",
          organization: response.data.data.organization_name || "",
          designation: response.data.data.designation || "",
          email: response.data.data.email || "",
          mobile: response.data.data.phone || "",
          address: response.data.data.address || "",
          photo: response.data.data.photo || null,
          district_id: response.data.data.district_id || null,
          upazila_id: response.data.data.upazila_id || null,
        });
      } catch (error) {
        console.error("Error fetching profile data:", error);
        setUserType("user"); // Default to 'user' on error
      }
    };

    fetchProfileData();
  }, []); // Run only once when the component mounts

  // Define the message based on user type
  const getMessage = () => {
    if (userType === "user") {
      return (
        <p>
          আপনার উপজেলা ও নির্বাচিত ক্যাটাগরি অনুযায়ী নিয়মিত টেন্ডার আপডেট পেতে, আপনার ইমেইল, জেলা, উপজেলা এবং ইমেইল ঠিকানাসহ সম্পূর্ণ প্রোফাইল "Edit Profile" থেকে আপডেট করুন | যদি টেন্ডারের ক্যাটাগরি ইতিপূর্বে নির্বাচিত না থাকে, "Selected Category" Change অপশন থেকে ক্যাটাগরি নির্বাচন কিংবা পরিবর্তন করতে চাইলে পরিবর্তন করতে পারবেন। বর্তমান পাসওয়ার্ড পরিবর্তন করতে "পাসওয়ার্ড পরিবর্তন" অপশনে গিয়ে নতুন পাসওয়ার্ড আপডেট করে নিন। অন্য কোনো বিষয়ে টেন্ডারওয়াইজ-এর সাথে যোগাযোগ করতে চাইলে, "Get Support" অপশন ব্যবহার করে আমাদের সাথে যোগাযোগ করুন।

          যেকোনো ধরনের টেন্ডার TenderWise-এ প্রকাশ করতে চাইলে Tender Publish ফর্মে Tender File (Image/PDF), কোম্পানির ফোন নম্বর এবং টেন্ডারের নামসহ প্রয়োজনীয় তথ্য পূরণ করে অনুরোধ পাঠালে, TenderWise-থেকে Verification না হওয়া পর্যন্ত View & Edit My Tender থেকে কোনো তথ্য আপডেট এবং স্ট্যাটাস দেখতে পারবেন। Verification সম্পন্ন হলে Pay Now অপশন আসবে, যেখানে bKash, Nagad, Rocket বা কার্ডের মাধ্যমে পেমেন্ট সম্পন্ন করার ৭২ ঘণ্টার মধ্যে টেন্ডারটি সম্পূর্ণ বিবরণ ও tender file সহ TenderWise-এ প্রকাশিত হবে। প্রকাশিত হওয়ার পর, View All My Published Tender থেকে আপনি আপনার পাঠানো টেন্ডারগুলো user কিভাবে দেখবে সেটা দেখতে পারবেন।

          যদি আপনি ইতিপূর্বে Premium Package সাবস্ক্রাইব না করেন, তাহলে আপনি সব টেন্ডার দেখতে পারবেন না, "Keyword Search" ব্যবহার করে শুধুমাত্র ফ্রি টেন্ডারগুলি খুঁজে দেখতে পারবেন। কোম্পানি বা প্রতিষ্ঠানের নাম, কতজন টেন্ডারটি দেখেছে, এবং নির্দিষ্ট তারিখ থেকে নির্দিষ্ট তারিখ পর্যন্ত টেন্ডারের সমস্ত ধরন তারিখ অনুযায়ী, Location, Tender Pattern, Live, Expired, Private, Govt, Source সহ সব ধরনের "Advance Search" ফিচার পেতে, এবং প্রয়োজনীয় টেন্ডার favourite list-এ সংরক্ষণসহ premium সব ফিচার ব্যবহার করতে, আপনাকে "Pricing/Renew" থেকে একটি প্যাকেজ কিনতে হবে। তখন আপনি সব ধরনের টেন্ডার দেখতে পারবেন এবং প্রতিদিন email-এ alert পাবেন।

          প্যাকেজ কেনার পর, "Bill Status" থেকে আপনার পেমেন্ট হিস্ট্রি দেখতে পারবেন এবং "Invoice" ডাউনলোড করতে পারবেন। আপনার মূল্যবান মতামত "Feedback" অপশন থেকে শেয়ার করতে পারবেন।
        </p>
      );
    } else if (userType === "end_user" || userType === "affiliator") {
      return (
        <p>
          আপনার উপজেলা ও নির্বাচিত ক্যাটাগরি অনুযায়ী নিয়মিত টেন্ডার আপডেট পেতে, আপনার ইমেইল, জেলা, উপজেলা এবং ইমেইল ঠিকানাসহ সম্পূর্ণ প্রোফাইল "Edit Profile" থেকে আপডেট করুন | যদি টেন্ডারের ক্যাটাগরি ইতিপূর্বে নির্বাচিত না থাকে, "Selected Category" Change অপশন থেকে ক্যাটাগরি নির্বাচন কিংবা পরিবর্তন করতে চাইলে পরিবর্তন করতে পারবেন। বর্তমান পাসওয়ার্ড পরিবর্তন করতে "পাসওয়ার্ড পরিবর্তন" অপশনে গিয়ে নতুন পাসওয়ার্ড আপডেট করে নিন। অন্য কোনো বিষয়ে টেন্ডারওয়াইজ-এর সাথে যোগাযোগ করতে চাইলে, "Get Support" অপশন ব্যবহার করে আমাদের সাথে যোগাযোগ করুন।

          যেকোনো ধরনের টেন্ডার TenderWise-এ প্রকাশ করতে চাইলে Tender Publish ফর্মে Tender File (Image/PDF), কোম্পানির ফোন নম্বর এবং টেন্ডারের নামসহ প্রয়োজনীয় তথ্য পূরণ করে অনুরোধ পাঠালে, TenderWise-থেকে Verification না হওয়া পর্যন্ত View & Edit My Tender থেকে কোনো তথ্য আপডেট এবং স্ট্যাটাস দেখতে পারবেন। Verification সম্পন্ন হলে Pay Now অপশন আসবে, যেখানে bKash, Nagad, Rocket বা কার্ডের মাধ্যমে পেমেন্ট সম্পন্ন করার ৭২ ঘণ্টার মধ্যে টেন্ডারটি সম্পূর্ণ বিবরণ ও tender file সহ TenderWise-এ প্রকাশিত হবে। প্রকাশিত হওয়ার পর, View All My Published Tender থেকে আপনি আপনার পাঠানো টেন্ডারগুলো কিভাবে দেখাবে সেটা দেখতে পারবেন।
        </p>
      );
    } else {
      // Default message if no matching user type
      return <p>Invalid user type or user information not found</p>;
    }
  };

  return (
    <div>
      {/* Welcome Message (This will always stay) */}
      <p className="font-bold text-xl text-[#FEA159] p-2">
        Welcome <span className="font-semibold">{userName},</span>
      </p>

      {/* Info Box (Can be closed) */}
      {isVisible && (
        <div className="relative mb-2">
          <div className="bg-orange-100 text-xs p-4 rounded text-blue-800 relative shadow">
            {/* Close Button */}
            <button
              onClick={() => setIsVisible(false)}
              className="absolute top-1 right-1 text-blue-800 hover:text-blue-600"
            >
              <X size={16} />
            </button>

            {/* Display the message based on user_type */}
            {getMessage()}
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomeMessage;





